import * as actions from "./actions/actions";
import cacheKeys from "@src/common/config/cacheKeys";
import { Cache } from "$utils";
import { localStorage } from "@src/common/lib/storage";
const common = {
  actions,
  state: {
    // 播放器是否下载
    isDownload: Cache.get("isDownload") || false,
    // 播放器信息
    playInfo: Cache.get("playInfo") || {},
    // 播放器是否初始化
    isInitPlay: Cache.get("isInitPlay") || false,
    // 当前页面标题
    pageTitle: localStorage.getString(cacheKeys.PAGE_TITLE) || "",
    //出入口值守
    broadcastMessage: localStorage.getString(cacheKeys.BROADCAST_MESSAGE) || [],
    // 当前语种
    currentLanguage: localStorage.getString(cacheKeys.CURRENT_LANGUAGE) || "",

    // 当前页面主题
    currentTheme: localStorage.getString(cacheKeys.CURRENT_THEME) || "",
    // 当前页面表格条数
    currentPagesize: localStorage.getString(cacheKeys.CURRENT_PAGESIZE) || "",
    // 当前登录的用户信息，只保持用户基本信息
    userInfo: localStorage.getObject(cacheKeys.CACHE_USER_INFO) || null,
    // 用户菜单权限数据，数据单独存储：用于做权限控制，和菜单展示
    userAuthMenu: localStorage.getObject(cacheKeys.USER_AUTH_MENU) || [],
    // 当前用户的中心数据，页面顶部的中心切换区域的当前中心
    currentCenterInfo:
      localStorage.getObject(cacheKeys.CURRENT_CENTER_INFO) || {},
    // 页面已打开菜单页签列表
    menuTabsList: localStorage.getObject(cacheKeys.MENU_TABS_LIST) || [],
    menuMap: localStorage.getObject(cacheKeys.MENU_MAP) || {},
    access_token: localStorage.getObject(cacheKeys.ACCESS_TOKEN) || "",
    map_click: {},
    map_ready: false,
    isFullScreen: false,
    map_options: Cache.get("MAP_OPTIONS") || [],
    system_settings: Cache.get("SYS_YUZHI") || [],
    mapType: Cache.get("MAP_TYPE") || "2d",
    carPassRecord: localStorage.getObject("CAR_PASS_RECORD") || {},
    alarmCount: 0,
    networkType: localStorage.getString("NETWORK_TYPE") || "CLOUD",
    alarmList: localStorage.getObject("ALARM_LIST") || []
  },
  getters: {
    getAlarmList: (state) => state.alarmList,
    pageTitle(state) {
      return state.pageTitle;
    },
    broadcastMessage(state) {
      console.log(3);
      return state.broadcastMessage;
    },
    currentLanguage(state) {
      return state.currentLanguage;
    },
    isDownload(state) {
      return state.isDownload;
    },
    playInfo(state) {
      return state.playInfo;
    },
    isInitPlay(state) {
      return state.isInitPlay;
    },
    currentTheme(state) {
      return state.currentTheme;
    },
    userInfo(state) {
      return state.userInfo;
    },
    access_token(state) {
      return state.access_token;
    },
    userAuthMenu(state) {
      return state.userAuthMenu;
    },
    currentCenterInfo(state) {
      return state.currentCenterInfo;
    },
    menuTabsList(state) {
      return state.menuTabsList;
    },
    menuMap(state) {
      return state.menuMap;
    },
    isFullScreen(state) {
      return state.isFullScreen;
    },
    // 面包屑导航
    breadcrumbs: (state) => state.common.breadcrumb,
    // 地图配置
    map_options(state) {
      return state.map_options;
    },
    // map_options: state => state.sys.map_options,
    scoket: (state) => state.sys.scoket,
    //显示子级菜单
    showChildrenMenus: (state) => state.common.showChildrenMenus,
    system_settings(state) {
      return state.system_settings;
    },
    mapType: (state) => {
      return state.mapType;
    },
    carPassRecord: (state) => {
      return state.carPassRecord;
    },
    alarmCount: (state) => {
      return state.alarmCount;
    },
    networkType: (state) => {
      return state.networkType;
    }
  },
  mutations: {
    [cacheKeys.PAGE_TITLE](state, data) {
      state.pageTitle = data;
      localStorage.setString(cacheKeys.PAGE_TITLE, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.PAGE_TITLE);
      }
    },
    [cacheKeys.CURRENT_LANGUAGE](state, data) {
      state.currentLanguage = data;
      localStorage.setString(cacheKeys.CURRENT_LANGUAGE, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.CURRENT_LANGUAGE);
      }
    },
    [cacheKeys.CURRENT_THEME](state, data) {
      state.currentTheme = data;
      localStorage.setString(cacheKeys.CURRENT_THEME, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.CURRENT_THEME);
      }
    },
    [cacheKeys.CURRENT_PAGESIZE](state, data) {
      state.currentPagesize = data;
      localStorage.setString(cacheKeys.CURRENT_PAGESIZE, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.CURRENT_PAGESIZE);
      }
    },
    [cacheKeys.CACHE_USER_INFO](state, data) {
      state.userInfo = data;
      localStorage.setObject(cacheKeys.CACHE_USER_INFO, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.CACHE_USER_INFO);
      }
    },
    [cacheKeys.USER_AUTH_MENU](state, data) {
      state.userAuthMenu = data;
      localStorage.setObject(cacheKeys.USER_AUTH_MENU, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.USER_AUTH_MENU);
      }
    },
    [cacheKeys.CURRENT_CENTER_INFO](state, data) {
      state.currentCenterInfo = data;
      localStorage.setObject(cacheKeys.CURRENT_CENTER_INFO, data);
      if (data === undefined || data === null || data === "" || data == []) {
        localStorage.removeItem(cacheKeys.CURRENT_CENTER_INFO);
      }
    },
    [cacheKeys.MENU_TABS_LIST](state, data) {
      state.menuTabsList = data;
      localStorage.setObject(cacheKeys.MENU_TABS_LIST, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.MENU_TABS_LIST);
      }
    },
    [cacheKeys.MENU_MAP](state, data) {
      state.menuMap = data;
      localStorage.setObject(cacheKeys.MENU_MAP, data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem(cacheKeys.MENU_MAP);
      }
    },
    fullScreen(state, data) {
      state.isFullScreen = data;
    },
    SET_ACCESS_TOKEN: (state, access_token) => {
      state.access_token = access_token;
      Cache.put("access_token", state.access_token);
    },
    SET_OCX: (state, data) => {
      const dataOps = data.returnObj;
      Cache.put("OCX_OPTIONS", dataOps);
      Cache.put(
        "VCM_INFO",
        dataOps && dataOps.vcmPlatInfo && dataOps.vcmPlatInfo.length
          ? dataOps.vcmPlatInfo[0]
          : [
              {
                vcmPlatCode: ""
              }
            ]
      );
    },
    SET_BROADCAST_MESSAGE: (state, data) => {
      console.log(data);
      if (!data) return;
      // 过滤同一个出入口和设备的推送
      if (
        state.broadcastMessage.some((el) => {
          return (
            el.sceneCode == data.sceneCode &&
            el.thirdDeviceId == data.thirdDeviceId
          );
        })
      ) {
        return;
      }
      const list = [data, ...state.broadcastMessage];
      state.broadcastMessage = list;
      localStorage.setObject("BROADCAST_MESSAGE", list);
    },
    REMOVE_BROADCAST_MESSAGE: (state, data) => {
      // 去除已处理的推送
      let index = state.broadcastMessage.findIndex((el) => {
        return (
          el.sceneCode == data.sceneCode &&
          el.thirdDeviceId == data.thirdDeviceId
        );
      });
      if (index == -1) {
        return;
      }
      const list = [...state.broadcastMessage];
      list.splice(index, 1);
      state.broadcastMessage = list;
      localStorage.setObject("BROADCAST_MESSAGE", list);
    },
    SET_SYS: (state, data) => {
      Cache.put("SYS_YUZHI", data);
    },
    SET_VPD: (state, data) => {
      Cache.put("SYS_VPD", data);
    },
    SET_VOICE: (state, data) => {
      Cache.put("SYS_VOICE", data);
    },
   SET_VEHICLE: (state, data) => {
      Cache.put("SYS_VEHICLE", data);
    },
    SET_TURNSTILE: (state, data) => {
      Cache.put("SYS_TURNSTILE", data);
    },
    SET_PARKINGLOT: (state, data) => {
      Cache.put("SYS_PARKINGLOT", data);
    },
    SET_H5: (state, data) => {
      Cache.put("SYS_H5", data);
    },
    SET_MAP_TYPE: (state, data) => {
      state.mapType = data;
      Cache.put("MAP_TYPE", data);
    },
    SET_ISDownload: (state, data) => {
      state.isDownload = data;
      Cache.put("isDownload", data);
    },
    SET_PlayInfo: (state, data) => {
      state.playInfo = data;
      Cache.put("playInfo", data);
    },
    SET_isInitPlay: (state, data) => {
      state.isInitPlay = data;
      Cache.put("isInitPlay", data);
    },
    CAR_PASS_RECORD: (state, data = {}) => {
      let oldRecord = state.carPassRecord;
      // 为了进行数据去重，目前后台未做数据去重，前端暂时规避完成
      if (
        oldRecord.deviceId === data.deviceId &&
        oldRecord.plateCode === data.plateCode &&
        oldRecord.passTime === data.passTime
      ) {
        return;
      }
      state.carPassRecord = data;
      localStorage.setObject("CAR_PASS_RECORD", data);
    },
    SET_ALARM_COUNT: (state, data) => {
      state.alarmCount = data;
    },
    SET_NETWORK_TYPE: (state, data) => {
      state.networkType = data;
      localStorage.setString("NETWORK_TYPE", data);
      if (data === undefined || data === null || data === "") {
        localStorage.removeItem("NETWORK_TYPE");
      }
    },
    ADD_ALARM_TO_LIST: (state, data) => {
      if (!data) return;
      const list = [data, ...state.alarmList];
      state.alarmList = list;
      localStorage.setObject("ALARM_LIST", list);
    },
    REMOVE_ALARM_FROM_LIST: (state, id) => {
      if (!id) {
        state.alarmList = [];
        localStorage.setObject("ALARM_LIST", []);
      }
    }
  }
};
export default common;
